import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import { LOGO_URL } from "@/lib/data";
import { FadeIn } from "@/components/Reveal";

const SOCIALS = [
  { name: "Instagram", href: "#", Icon: Instagram },
  { name: "Facebook", href: "#", Icon: Facebook },
  { name: "LinkedIn", href: "#", Icon: Linkedin },
  { name: "YouTube", href: "#", Icon: Youtube },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative bg-bm-navy text-white grain overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-12">
      <FadeIn>
        <Link to="/contact" data-testid="footer-lets-talk-link" className="group block">
          <p className="font-manrope text-xs font-bold uppercase tracking-[0.3em] text-white/50 mb-4">
            Have a project in mind?
          </p>
          <h2 className="font-syne font-extrabold leading-none tracking-tighter text-6xl sm:text-8xl lg:text-9xl">
            LET'S{" "}
            <span className="text-stroke-white transition-colors duration-500 group-hover:text-bm-blue group-hover:[-webkit-text-stroke:0px]">
              TALK
            </span>
            <ArrowUpRight className="inline-block ml-4 h-12 w-12 sm:h-20 sm:w-20 text-bm-blue transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2" />
          </h2>
        </Link>
      </FadeIn>

      <div className="mt-20 pt-10 border-t border-white/10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="inline-block rounded-xl bg-white px-4 py-2">
            <img src={LOGO_URL} alt="Brand Mitra 24" className="h-10 w-auto" />
          </div>
          <p className="mt-5 max-w-sm font-manrope text-sm leading-relaxed text-white/60">
            Creative thinking, around the clock. A full-stack digital marketing
            and advertising agency for brands that refuse to sleep.
          </p>
        </div>
        <div>
          <p className="font-syne text-sm font-bold uppercase tracking-widest text-white/40 mb-4">
            Navigate
          </p>
          <ul className="space-y-3 font-manrope text-sm">
            {[
              ["Home", "/"],
              ["Services", "/services"],
              ["About", "/about"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="text-white/70 transition-colors duration-300 hover:text-bm-blue"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-syne text-sm font-bold uppercase tracking-widest text-white/40 mb-4">
            Reach Us
          </p>
          <ul className="space-y-3 font-manrope text-sm text-white/70">
            <li>hello@brandmitra24.com</li>
            <li>+91 97691 08757</li>
            <li>Abhijit Apartment, Old Prabhadevi Road, Mumbai 400 025</li>
            <li className="flex items-center gap-2 text-bm-blue">
              <Clock className="h-4 w-4" /> Open 24/7 — literally
            </li>
          </ul>
          <div className="mt-6 flex gap-3" data-testid="footer-social-links">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a
                key={name}
                href={href}
                data-testid={`social-link-${name.toLowerCase()}`}
                aria-label={`Brand Mitra 24 on ${name}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-bm-blue hover:bg-bm-blue hover:text-white"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-manrope text-xs text-white/40">
        <span>© 2026 Brand Mitra 24. All rights reserved.</span>
        <span>Creative thinking, around the clock.</span>
      </div>
    </div>
  </footer>
);
